export default "__VITE_ASSET__DLWWPxuf__"